/* eslint-disable import/prefer-default-export */
import * as req from 'api/actions';
import alert from 'react-s-alert';
import { omitEmptyArgs } from 'helper';
import * as c from './constant';

export const getRegionList = (payload, callback) =>
  req.list(
    c.GET_REGION,
    'api/v1/administrators/address/regions',
    payload,
    callback
  );

export const getProvinceList = (payload, callback) =>
  req.list(
    c.GET_PROVINCE,
    'api/v1/administrators/address/provinces',
    payload,
    callback
  );

export const getMunicipalityList = (payload, callback) =>
  req.list(
    c.GET_MUNICIPALITIES,
    'api/v1/administrators/address/municipalities',
    payload,
    callback
  );

export const getBarangayList = (payload, callback) =>
  req.list(
    c.GET_BARANGAYS,
    'api/v1/administrators/address/barangays',
    payload,
    callback
  );

export const getMachineryOwnerList = (payload, callback) =>
  req.list(
    c.GET_MACHINERY_OWNER,
    'api/v1/rpt/administrator/machineries/machinery_owners?isPaginate=1',
    omitEmptyArgs(payload),
    callback
  );

export const getSingleMachineryOwner = (id, payload, callback) =>
  req.item(
    c.GET_SINGLE_MACHINERY_OWNER,
    `api/v1/rpt/administrator/machineries/machinery_owners/${id}`,
    payload,
    callback
  );

export const createMachineryOwner = (payload, callback) =>
  req.create(
    c.CREATE_MACHINERY_OWNER,
    'api/v1/rpt/administrator/machineries/machinery_owners',
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateMachineryOwner = (id, payload, callback) =>
  req.update(
    c.UPDATE_MACHINERY_OWNER,
    `api/v1/rpt/administrator/machineries/machinery_owners/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const removeMachineryOwner = (id, payload, callback) =>
  req.remove(
    c.REMOVE_MACHINERY_OWNER,
    `api/v1/rpt/administrator/machineries/machinery_owners/${id}`,
    payload,
    (res) => {
      const { message } = res.res;
      alert.success(message || 'Successfully Removed !');
      if (callback) callback();
    }
  );
